import { environmentDefaults } from './environment.default';

export const environment = {
    ...environmentDefaults,
    debug: false,
    hmr: false,
    name: 'prod'
};
